import React from "react";
import MTab from "@mui/material/Tab";

export const Tab = React.memo((props) => <MTab {...props} />);
export default Tab;